import { UPDATE_CONFERENCE_METADATA } from '../base/conference/actionTypes';
import { getCurrentConference } from '../base/conference/functions';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { SET_FEATURE_CONTROL } from './actionTypes';
import { updateFeatureControls } from './actions';
import { FEATURE_CONTROLS_METADATA_KEY } from './constants';
MiddlewareRegistry.register((store) => (next) => (action) => {
    switch (action.type) {
        case SET_FEATURE_CONTROL: {
            const result = next(action);
            const state = store.getState();
            const conference = getCurrentConference(state);
            const featureControls = state['features/feature-controls'];
            conference?.getMetadataHandler().setMetadata(FEATURE_CONTROLS_METADATA_KEY, featureControls);
            return result;
        }
        case UPDATE_CONFERENCE_METADATA: {
            const { metadata } = action;
            if (metadata?.[FEATURE_CONTROLS_METADATA_KEY]) {
                store.dispatch(updateFeatureControls(metadata[FEATURE_CONTROLS_METADATA_KEY]));
            }
            break;
        }
    }
    return next(action);
});
